import { TimelineEffect } from '@xzdarcy/react-timeline-editor';
import {
  CustomAction,
  isMusicType,
  isVideoType,
  checkoutVolume,
} from '@/components/Timeline/utils.ts';
import audioControl from '@/components/Timeline/audioControl.ts';
import videoControl from '@/components/Timeline/videoControl.ts';
import { TinyEmitter } from 'tiny-emitter';

export const ActionEvent = new TinyEmitter();
let topPriorityAction: CustomAction | undefined;
let actionsPerTick: CustomAction[] = [];
function addAction(action: CustomAction) {
  const index = actionsPerTick.findIndex((a) => a.id === action.id);
  if (index < 0) {
    actionsPerTick.push(action);
  }
  emitActionChanged();
}
function removeAction(action: CustomAction) {
  const index = actionsPerTick.findIndex((a) => a.id === action.id);
  if (index > -1) {
    actionsPerTick.splice(index, 1);
  }
  emitActionChanged();
}
function emitActionChanged() {
  const result = calcTopPriorityAction();
  if (result?.id !== topPriorityAction?.id) {
    topPriorityAction = result;
    ActionEvent.emit('action-changed', topPriorityAction);
  }
}
function calcTopPriorityAction() {
  if (actionsPerTick.length === 0) {
    return;
  } else {
    const videActions = actionsPerTick
      .filter(isVideoType)
      .sort((a, b) => a.trackIndex! - b.trackIndex!);
    if (videActions.length > 0) {
      return videActions[0];
    }
    const musicActions = actionsPerTick
      .filter(isMusicType)
      .sort((a, b) => a.trackIndex! - b.trackIndex!);
    if (musicActions.length > 0) {
      return musicActions[0];
    }
  }
}
export function resetActionsPerTick() {
  topPriorityAction = undefined;
  actionsPerTick = [];
}

export const effects: Record<string, TimelineEffect> = {
  effect0: {
    id: 'effect0',
    name: '播放视频',
    source: {
      start: ({ action, engine, isPlaying, time }) => {
        if (isPlaying) {
          const customAction = action as Required<CustomAction>;
          const { materialId, start, from, hide } = customAction;
          videoControl.start({
            id: materialId.toString(),
            startTime: start,
            engine,
            time,
            from,
            hide,
          });
        }
      },
      enter: ({ action, engine, isPlaying, time }) => {
        addAction(action as CustomAction);
        if (isPlaying) {
          const customAction = action as Required<CustomAction>;
          const { materialId, start, from, hide } = customAction;
          videoControl.start({
            id: materialId.toString(),
            startTime: start,
            engine,
            time,
            from,
            hide,
          });
        }
      },
      leave: ({ action, engine }) => {
        removeAction(action as CustomAction);
        const customAction = action as Required<CustomAction>;
        videoControl.leave({ id: customAction.materialId.toString(), engine });
      },
      stop: ({ action, engine }) => {
        const customAction = action as Required<CustomAction>;
        videoControl.stop({ id: customAction.materialId.toString(), engine });
      },
      update: ({ action, time, isPlaying }) => {
        if (!isPlaying) {
          const customAction = action as Required<CustomAction>;
          const { materialId, start, end, from, hide } = customAction;
          videoControl.update({
            id: materialId.toString(),
            startTime: start,
            endTime: end,
            from,
            time,
            hide,
          });
        }
      },
    },
  },
  effect1: {
    id: 'effect1',
    name: '播放音效',
    source: {
      start: ({ action, engine, isPlaying, time }) => {
        if (isPlaying) {
          const customAction = action as Required<CustomAction>;
          const { id, url, start, from, volume, speed, materialId, type, mute } = customAction;
          const new_volume = checkoutVolume(materialId, type, volume, mute);
          audioControl.start({
            id: id,
            src: url,
            startTime: start,
            engine,
            time,
            from,
            volume: new_volume,
            speed,
          });
        }
      },
      enter: ({ action, engine, isPlaying, time }) => {
        addAction(action as CustomAction);
        if (isPlaying) {
          const customAction = action as Required<CustomAction>;
          const { id, url, start, from, volume, speed, materialId, type, mute } = customAction;
          const new_volume = checkoutVolume(materialId, type, volume, mute);
          audioControl.start({
            id: id,
            src: url,
            startTime: start,
            engine,
            time,
            from,
            volume: new_volume,
            speed,
          });
        }
      },
      leave: ({ action, engine }) => {
        removeAction(action as CustomAction);
        const customAction = action as Required<CustomAction>;
        audioControl.stop({ id: customAction.id, engine });
      },
      stop: ({ action, engine }) => {
        const customAction = action as Required<CustomAction>;
        audioControl.stop({ id: customAction.id, engine });
      },
    },
  },
  effect2: {
    id: 'effect2',
    name: '播放字幕，目前用不到',
  },
};
